// extracted by mini-css-extract-plugin
export var skipAnimation = "_23-0";